module.exports = __webpack_public_path__ + "static/media/view5.4ee41424.jpg";